import React, { Component } from 'react'

export default class Subapp extends Component<any, any> {
  render (): any {
    const { loading } = this.props
    return (
      <>
        {loading && <h4 className="subapp-loading">Loading...</h4>}
        <div id="subapp-viewport" style={{ height: '100%' }} />
      </>
    )
  }
}
